import { compose, withHandlers } from 'recompose';
import { withDataLayerPush } from '../withDataLayerPush';

// This push dataLayer by method
// eslint-disable-next-line
export const withDataLayerActivateVoucher = compose(
  withDataLayerPush,
  withHandlers({
    dataLayerActivateVoucher: ({ dataLayerPush }) => ({
      platform = 'web'
    }) => {
      dataLayerPush({
        event: 'voucherActivation',
        ecommerce: {
          activateVoucher: {
            platform
          }
        }
      });
    }
  }),
);



// WEBPACK FOOTER //
// ./src/Common/GTM/ECommerceTracking/withDataLayerActivateVoucher.js